import { InsightBullet } from '../../../lib/types'

const SIGNAL_CONFIG = {
  up:          { icon: '↑', color: '#22c55e', bg: 'rgba(34,197,94,0.08)' },
  alert:       { icon: '!', color: '#ef4444', bg: 'rgba(239,68,68,0.08)' },
  action:      { icon: '→', color: '#a855f7', bg: 'rgba(168,85,247,0.08)' },
  opportunity: { icon: '◉', color: '#f59e0b', bg: 'rgba(245,158,11,0.08)' },
} as const

interface Props {
  bullets: InsightBullet[]
}

export default function AIAnnotation({ bullets }: Props) {
  if (!bullets || bullets.length === 0) return null

  return (
    <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
      {bullets.map((b, i) => {
        const cfg = SIGNAL_CONFIG[b.signal as keyof typeof SIGNAL_CONFIG] ?? SIGNAL_CONFIG.up
        return (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 8,
              background: cfg.bg,
              borderLeft: `2px solid ${cfg.color}`,
              borderRadius: 4,
              padding: '5px 8px',
              fontSize: 12,
            }}
          >
            <span style={{ color: cfg.color, fontWeight: 700, flexShrink: 0 }}>{cfg.icon}</span>
            <span>
              <strong style={{ color: cfg.color }}>{b.label}</strong>
              <span style={{ color: 'var(--color-text-body-secondary, #64748b)' }}> — {b.detail}</span>
            </span>
          </div>
        )
      })}
    </div>
  )
}
